import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
const SUMMARY_CSS = css `
  cursor: pointer;
`;
const UL_CSS = css `
  margin: 0;
`;
export const PasswordRequirementsDetails = ({ isOpen }) => {
    return (_jsxs("details", { open: isOpen ? true : undefined, children: [_jsx("summary", { css: SUMMARY_CSS, children: "Password Requirements" }), _jsxs("ul", { css: UL_CSS, children: [_jsx("li", { children: "At least 12 characters" }), _jsx("li", { children: "At least 1 uppercase, digit, or special character" })] })] }));
};
